import { Link, useNavigate } from "react-router";
import { Button, Card, Icon, SegmentedControl, useConfirm } from "@xinghai/ui";
import type { ThemeMode } from "@xinghai/ui";
import { THEME_LABELS, useTheme } from "../../app/theme";
import { useSettings } from "../../lib/settings";
import { useLogout } from "../auth/useAuth";
import { ProfileCard } from "../account/ProfileCard";

/** docs/UX.md §4 — 设置页：外观、自动提交、账号与安全. */
export function SettingsPage() {
  const { theme, setTheme } = useTheme();
  const [settings, setSetting] = useSettings();
  const logout = useLogout();
  const confirm = useConfirm();
  const navigate = useNavigate();

  return (
    <div className="xz-container xz-container--readable xz-stack">
      <h1 className="gz-type-heading">设置</h1>

      <Card title="外观" padding="md">
        <SegmentedControl<ThemeMode>
          label="界面外观"
          options={(["system", "light", "dark"] as ThemeMode[]).map((m) => ({
            value: m,
            label: THEME_LABELS[m],
          }))}
          value={theme}
          onChange={setTheme}
        />
      </Card>

      <Card title="录音" padding="md">
        <label className="xz-switch">
          <span className="xz-switch__text">
            <span className="xz-switch__title">录完自动提交</span>
            <span className="gz-caption">
              停止后直接提交，3 秒内可以撤销。关掉的话，每条都要自己点「提交」。
            </span>
          </span>
          <input
            type="checkbox"
            role="switch"
            className="xz-switch__input"
            checked={settings.autoSubmit}
            aria-label="录完自动提交"
            onChange={(e) => setSetting("autoSubmit", e.target.checked)}
          />
          <span className="xz-switch__track" aria-hidden="true">
            <span className="xz-switch__knob" />
          </span>
        </label>
      </Card>

      <ProfileCard />

      <Card title="账号与安全" padding="md">
        <div className="xz-account__links">
          <Link className="gz-button" to="/account/password">
            <Icon id="ui-key" size={20} /> 修改密码
          </Link>
          <Link className="gz-button" to="/account/devices">
            <Icon id="ui-shield" size={20} /> 我的设备
          </Link>
          <Link className="gz-button" to="/account/email">
            <Icon id="ui-inbox" size={20} /> 找回邮箱
          </Link>
          <Link className="gz-button" to="/account/phone">
            <Icon id="ui-key" size={20} /> 找回手机
          </Link>
          <Button
            variant="secondary"
            loading={logout.isPending}
            onClick={async () => {
              const ok = await confirm({ title: "退出登录？", confirmLabel: "退出" });
              if (!ok) return;
              await logout.mutateAsync().catch(() => undefined);
              void navigate("/login", { replace: true });
            }}
          >
            <Icon id="ui-logout" size={20} /> 退出登录
          </Button>
        </div>
      </Card>
    </div>
  );
}
